module.exports = __webpack_public_path__ + "media/assets/services_manager/banners/BRIDGEU-5e3098e3e2d84ff31a958ebd1a7017a3ade535793c4f1572c2a10d5c709088ab.png";